export default __webpack_public_path__ + "static/media/Group 561.bb223733.png";